module.exports = __webpack_public_path__ + "static/office_11-bea773d3a0944494e9891d3318288e92.jpg";